export default {
  spendField: 'thirty_day_spend',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 100,
      field: 'adpi',
      label: 'AdPi Score',
      format: '.0f',
      scale: [100, 180]
    },
    {
      metric: 112,
      field: 'recall',
      label: 'Branded Recall',
      format: '.0%',
      hasSpendData: true,
      scale: [0, 0.8]
    },
    {
      metric: 121,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 0.8]

    },
    {
      metric: 123,
      field: 'actions',
      label: 'Net Actions',
      format: '.0%', 
      scale: [0, 0.8]
    },
    {
      metric: 122,
      field: 'impression',
      label: 'Lift to Impression',
      format: '.0%',
      scale: [0, 0.8]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/app/configuration/Square/config/components/scorecard/Trendchart/index.js